import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { StatusFiscalNFSeEntradaLookupStruct } from '../../../../../shared/services/structs/repo-dfse/status-fiscal-nfse-entrada-lookup.struct';

@Component({
  selector: 'app-servico-tomado-dados-cabecalho',
  standalone: true,
  imports: [ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatSelectModule, MatDatepickerModule, MatIconModule],
  templateUrl: './servico-tomado-dados-cabecalho.component.html',
})
export class ServicoTomadoDadosCabecalhoComponent {
  @Input({ required: true }) form!: FormGroup;
  @Input() listaStatusFiscal: StatusFiscalNFSeEntradaLookupStruct[] = [];
}
